import { Injectable } from '@angular/core';
import { DatosEmpresaDto } from './DatosEmpresaDto';
import { environment } from 'src/environments/environment';
import { HttpApiService } from '../http/http-api.service';
import { EmpresaResumenDto, EmpresaResumenResponse } from './empresasdto';
import { ToastService } from '../toast.service';
import { Provincia } from 'src/app/dto/Provincia';
import { HistoricoEmpresaDto } from 'src/app/modals/historico-empresa/HistoricoEmpresaDto';


@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  empresa?: DatosEmpresaDto;
  empresaTemp?: DatosEmpresaDto;
  //Array de provincias
  provincias?: Provincia[];

  constructor(private http: HttpApiService, private toast: ToastService) {
    console.log("Empresa service constructor");
  }

  getEmpresaById(id: string): Promise<DatosEmpresaDto>{

    return this.http.getApi(environment.apiGetEmpresa + id).then((data:DatosEmpresaDto) =>  {
      return data;
    }, (error) => {
      this.toast.add({severity:'error', summary:'Error', detail:error.error.responseMessage});
      return Promise.reject(error);
    }) ;

  }

/**
 * Realiza la carga de los datos de la empresa logada actualmente en el sistema
 * En caso de devolver un 404 se considera que la empresa no está dada de alta y se mostrará el dialogo de registro incial.
 * @returns
 */
  loadDatosEmpresa(): Promise<DatosEmpresaDto>{

    if(this.empresa != null){
      return Promise.resolve(this.empresa);
    }

    return this.http.getApi(environment.apiEmpresaGetDatos).then((data:DatosEmpresaDto) =>  {


      this.empresa = data;
      return this.empresa;

    }, (errorLoad) => {
      console.log("Error");
      console.log(errorLoad.error);

      if(errorLoad.status == 404){
        return Promise.reject(errorLoad.error);
      }
      return Promise.reject(errorLoad);
    }

    ) ;
  }

  loadDatosEmpresaAESANYCartera(idEmpresa: string): Promise<DatosEmpresaDto>{

    if(this.empresa != null){
      return Promise.resolve(this.empresa);
    }


    return this.http.getApi(environment.apiDatosEmpresaAESAN + "/" + idEmpresa).then((data:DatosEmpresaDto) =>  {
      return data;

    }, (errorLoadAESAN) => {
      console.log("Error");
      console.log(errorLoadAESAN.error);

      if(errorLoadAESAN.status == 404){
        return Promise.reject(errorLoadAESAN.error);
      }
      return Promise.reject(errorLoadAESAN);
    }

    ) ;
  }

  loadVersionEmpresa(empresaVersionId : number | undefined) : Promise<DatosEmpresaDto>{
    return this.http.getApi(environment.apiEmpresaVersionGetDatos + "/" + empresaVersionId).then((data:DatosEmpresaDto) =>  {
      return data;
    }, (error) => {
      return Promise.reject(error);
    });
  }

  /**
   * Devuelve los datos actuales de la empresa
   * @returns
   */
  getMyData():DatosEmpresaDto|undefined{
    return this.empresa;
  }


  saveEmpresa(empresa: DatosEmpresaDto) {
    console.log("saveEmpresa");
    return this.http.postApi(environment.apiEmpresaPutDatos,empresa).then((data:DatosEmpresaDto) =>  {

      this.empresa = data;

      return this.empresa;

    }, (error) => {

      console.log("Error");

      console.log(error.error);
      this.toast.add({severity:'error', summary:'Error', detail:error.error.responseMessage});

        if(error.status == 404){
          return Promise.reject(error.error);
        }
        return Promise.reject(error);
    }

    ) ;

  }

  /**Obtiene el listado de todas las empresas, de uso únicamente para CARTERA */

  getEmpresasCartera(): Promise<EmpresaResumenDto[]>{


    return this.http.postApi(environment.apiGetListadoEmpresas, {todas: true}).then((empresas:EmpresaResumenResponse) =>  {
      return empresas.resumen;
    }, (error) => {
      this.toast.add({severity:'error', summary:'Error', detail:error.error.responseMessage});
      return Promise.reject(error);
    }) ;
  }

  /**Obtiene el array de provincias */
  getProvincias(): Promise<Provincia[]>{

    if(this.provincias != null){
      return Promise.resolve(this.provincias);
    }

    return this.http.getApi(environment.apiGetProvincias).then((provincias:Provincia[]) =>  {
      return provincias;
    }, (error) => {
      this.toast.add({severity:'error', summary:'Error', detail:error.error.responseMessage});
      return Promise.reject(error);
    }) ;
  }

  getHistoricoEmpresa(empresaId: string): Promise<HistoricoEmpresaDto[]> {
    return this.http.getApi(environment.apiGetHistoricoEmpresa + empresaId).then((historico:HistoricoEmpresaDto[]) =>  {
      return historico;
    }, (error) => {
      this.toast.add({severity:'error', summary:'Error', detail:error.error.responseMessage});
      return Promise.reject(error);
    }) ;
  }

}
